import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import EditableInfo from "@builder/components/editable/EditableInfo";
import { EditableProps } from "@builder/components/editable/editableProps";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { useAppSelector } from "@builder/store/store";
import { BuildNode } from "@common/build/types";
import { useTranslation } from "react-i18next";
import "./style.css";

const EditSection = ({ parent }: EditableProps) => {
    const selectedNode = useAppSelector(getSelectedNode) as BuildNode;
    
    const {t} = useTranslation();
  
    return (
        <SidebarCollapse title="Iframe" parent={parent}>
            <EditableInfo header={`${t("editableInfo.How does")} ${t("editableInfo." + selectedNode.name)} ${t("editableInfo.works")}`} body={t("editableInfo." +  selectedNode.name + ".body")} body2={
                t("editableInfo." + selectedNode.name + ".tip")
            } noTranslate />
        </SidebarCollapse>
    );
};

export default EditSection;
